import { useEffect, useState } from "react";
import { SpousalSupportSummary } from "../../../models/SpousalSupportSummary";
import { SpousalSupportService } from "../../../services/SpousalSupportService";
import { useMatter } from "../../../contexts/MatterContext";

const SpousalSupportSummaryComponent: React.FC = ({}) => {
  const { currentMatterId } = useMatter();
  const [summary, setSummary] = useState<SpousalSupportSummary | null>(null);

  useEffect(() => {
    if (!currentMatterId) return;
    const fetchSummary = async () => {
      try {
        const response =
          await SpousalSupportService.getSummary(currentMatterId);
        setSummary(response);
      } catch (error) {
        console.error("Error fetching summary:", error);
      }
    };

    fetchSummary();
  }, []);

  if (!summary) return null;
  return (
    <div className="p-6 mb-8 bg-white border shadow-sm rounded-2xl dark:bg-zinc-900">
      {/* First Row: 3 items */}
      <div className="grid grid-cols-1 gap-6 mb-6 sm:grid-cols-2 md:grid-cols-3">
        <StatCard
          title="Total Payments"
          value={summary.totalPayments.toLocaleString()}
        />
        <StatCard
          title="Total Paid"
          value={summary.totalAmount.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        />
      </div>
    </div>
  );
};

interface StatCardProps {
  title: string;
  value: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value }) => {
  return (
    <div className="flex flex-col p-4 border shadow-sm rounded-xl bg-muted/20 dark:bg-muted/10">
      <span className="text-sm font-medium text-muted-foreground">{title}</span>
      <span className="text-2xl font-bold">{value}</span>
    </div>
  );
};

export default SpousalSupportSummaryComponent;
